import {BrowserRouter} from "react-router-dom";
import { AuthProvider } from "./AuthContext.tsx";
import './css/App.css';
import AppContent from "./AppContent.tsx";

//--legacy-peer-deps

const App : React.FC = () =>
{
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
